import React, { useRef } from 'react';
import type { VirtualGridOverlayApiT } from '../../../../common/virtual-grid';
import { useFrameMarkerDrag } from '../../hooks/use-frame-marker-drag';
import { CurrentFrameMarker } from './current-frame-marker';
type FrameMarkerOverlayPropsT = {
  totalFrames: number;
  cellWidth: number;
  overlayControls: VirtualGridOverlayApiT;
};
export const FrameMarkerOverlay = ({
  totalFrames,
  cellWidth,
  overlayControls
}: FrameMarkerOverlayPropsT) => {
  const badgeRef = useRef<HTMLDivElement>(null);
  useFrameMarkerDrag(overlayControls, totalFrames, {
    badgeRef
  });
  return <CurrentFrameMarker totalFrames={totalFrames} cellWidth={cellWidth} badgeRef={badgeRef} />;
};